export default __webpack_public_path__ + "static/media/ticket.d429c140.svg";